import { Box, Button, Stack } from "@mui/material";
import Translate from "../../../utils/Translate";
import { Key } from "@mui/icons-material";
import { useEffect } from "react";
import LanguageIcons from "./LanguageIcons";

export default function ExternalAuthLoginForm({ redirectPath }) {
  function buildExternalLoginReturnUrl() {
    const protocol = window.location.protocol;
    const host = window.location.host;
    const path = redirectPath ?? window.location.pathname;
    return protocol + "//" + host + path;
  }

  return (
    <form className="loginForm">
      {!window.global.isKs && (
        <Box paddingBottom={3}>
          <LanguageIcons isPreLogin={true} />
        </Box>
      )}
      <Stack sx={{ paddingBottom: window.global.isKs ? 4 : 2 }} spacing={1}>
        <Button
          href={`${import.meta.env.VITE_AUTH_URL}auth/entra/login?returnUrl=${encodeURIComponent(buildExternalLoginReturnUrl())}`}
          startIcon={<img style={{ height: "20px", marginRight: "8px" }} src="/static/mssymbol.svg" />}
          sx={{ height: "48px" }}
          className={window.global.isKs ? "grayButtonText roundFlatButton" : null}
        >
          {Translate.get("SignInWithMicrosoft")}
        </Button>
        <Button
          href="/login"
          startIcon={<Key />}
          sx={{ height: "48px" }}
          className={window.global.isKs ? "grayButtonText roundFlatButton" : null}
        >
          {Translate.get("LogInUsingEmail")}
        </Button>
      </Stack>
    </form>
  );
}
